import { PurchaseDisputeRepository } from '../repositories/purchase-dispute.repository';
import { PurchaseDisputeRepositoryService } from '../repositories/purchase-dispute.service';

export const PurchaseDisputeProvider = [
  {
    provide: PurchaseDisputeRepository,
    useClass: PurchaseDisputeRepositoryService,
  },
];
